<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat protokol</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>
            </div>
            <protocol-form
                :entity="entity"
                ref="protocolformref"
            ></protocol-form>
          </section>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ProtocolForm from "@/components/views/protocols/ProtocolForm"
import protocols from "@/components/views/protocols/mixins/protocols"
import detailActions from "@/components/mixins/detail-actions"

export default {
  name: "ProtocolNew",
  components: {ProtocolForm},
  mixins: [detailActions, protocols],
  created(ProtocolService) {
    this.entityService = ProtocolService
  },
  methods: {
    _processDetailErrorMessage(error) {
      return this.processErrorMessage(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/protocols/ProtocolNew.vue